import react, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
  Button,
  Card,
  CardMedia,
  CardContent,
  Stack,
  Box,
  Typography,
  Avatar,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { notify, parseFormattedText } from "../Common";
import CallIcon from "@mui/icons-material/Call";
import LaunchIcon from "@mui/icons-material/Launch";
import { useAuth } from "../../Context/Auth";
import { debounce, set } from "lodash";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { loadTemplates as apiAllTemplates } from "../../API/TemplateLayer";
import { loadTemplates as apiPublishedTemplates } from "../../API/CampaignLayer";
import { templatePreview as apiTemplatePreview } from "../../API/TemplateLayer";
import { SendTemplates as apiSendTemplates } from "../../API/ChatLayer";
import { backend } from "../../API/CommonApi";
import { fetchProducts } from "../../API/TemplateLayer";

function SendMessageTemplate({
  rowData,
  isOpen,
  closeDialog,
  fetchMSGData,
  selectedChat,
  isSendDisabled,
}) {
  const methods = useForm({ mode: "onBlur" });
  const { control, formState, watch } = methods;
  const { errors } = formState;
  const watchAllFields = watch();
  const auth = useAuth();
  const wpDetails = auth.wpDetails?.[0];
  const appToken = wpDetails?.app_token;
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [template, setTemplate] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [fileName, setFileName] = useState("");
  const [products, setProducts] = useState([]);

  const resetTemplate = () => {
    setTemplate(null);
    methods.reset();
  };

  const loadTemplates = (text) => {
    setLoadingTemplates(true);
    if (!isSendDisabled) {
      apiPublishedTemplates(text)
        .then((res) => {
          setTemplates(res.data);
        })
        .catch((error) => {
          notify("error", "Something went wrong with templates");
        })
        .finally(() => {
          setLoadingTemplates(false);
        });
    } else {
      apiAllTemplates(text)
        .then((res) => {
          let templates = res.results;
          setTemplates(templates);
          for (var i = 2; i <= res.total_pages; i++) {
            apiAllTemplates("page=" + String(i))
              .then((res) => {
                setTemplates(templates.concat(res.results));
              })
              .catch((error) => {
                notify("error", "Something went wrong with templates");
              })
              .finally(() => {
                setLoadingTemplates(false);
              });
          }
        })
        .catch((error) => {
          notify("error", "Something went wrong with templates");
        })
        .finally(() => {
          setLoadingTemplates(false);
        });
    }
  };

  const handleSendTemplate = () => {
    if (template) {
      closeDialog();
      if (typeof selectedChat === "object") {
        selectedChat = selectedChat.contact?.phone_number;
      }
      return apiSendTemplates(selectedChat, wpDetails, template).then((res) => {
        if (fetchMSGData) {
          return fetchMSGData()
            .then((res) => {
              notify("success", "Message sent successfully");
              resetTemplate();
            })
            .catch((error) => {
              notify("error", "Something went wrong with sending message");
              resetTemplate();
            });
        } else {
          notify("success", "Message sent successfully");
          resetTemplate();
        }
      });
    }
  };
  const buildLocalUrl = (path) => (path ? `${backend}media/${path}` : null);

  const buildCardPreview = (cards) =>
    (Array.isArray(cards) ? cards : []).map((c) => ({
      ...c,
      image_url: c.image_url || buildLocalUrl(c.image_file_path),
      _preview_src: c.image_file
        ? URL.createObjectURL(c.image_file)
        : c.image_url || buildLocalUrl(c.image_file_path),
    }));

  const enrichSectionsWithProducts = (sections, productsList) =>
    (sections || []).map((s) => ({
      ...s,
      products: (s.product_ids || [])
        .map((rid) => productsList.find((p) => p.retailer_id === rid))
        .filter(Boolean),
    }));

  const enrichCardsWithProducts = (cards, productsList) =>
    (cards || []).map((c) => {
      if (!c.product_id) return c;
      const prod = productsList.find((p) => p.retailer_id === c.product_id);
      return prod
        ? {
            ...c,
            title: c.title || prod.name,
            price: c.price || prod.price,
            image_url: c.image_url || prod.image_url,
          }
        : c;
    });

  useEffect(() => {
    if (preview?.header) {
      var link = preview.header.split("?")[0];
      var file = link.split("/").pop();
      setFileName(file);
    }
  }, [preview]);

  const ifCallTOAction = (data) => {
    const buttons = typeof data === "string" ? JSON.parse(data) : data;
    if (
      buttons?.some((obj) => obj.type === "URL" || obj.type === "PHONE_NUMBER")
    ) {
      return (
        <div style={{ borderTop: "1px solid #dadde1" }}>
          {buttons?.map((item) => (
            <p
              style={{
                color: "#33b7f6",
                textAlign: "center",
                margin: "5px 0 0 0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                gap: "10px",
                fontWeight: "normal",
                padding: "10px 15px",
              }}
            >
              {item.type == "PHONE_NUMBER" ? (
                <CallIcon
                  style={{
                    width: "20px",
                    marginRight: "-5px",
                  }}
                />
              ) : item.url_type === "DYNAMIC_URL" ? (
                <LaunchIcon
                  style={{
                    width: "20px",
                    marginRight: "-5px",
                    color: "#666",
                  }}
                />
              ) : (
                <LaunchIcon
                  style={{
                    width: "20px",
                    marginRight: "-5px",
                  }}
                />
              )}
              <a
                href={item.url_type === "DYNAMIC_URL" ? "#" : item.url}
                style={{ color: "#33B7F6", textDecoration: "none" }}
                target={item.url_type !== "DYNAMIC_URL" ? "_blank" : undefined}
                onClick={item.url_type === "DYNAMIC_URL" ? (e) => e.preventDefault() : undefined}
              >
                {item.url_type === "DYNAMIC_URL" 
                  ? `${item.text} (dynamic)` 
                  : item.text}
              </a>
            </p>
          ))}
        </div>
      );
    }
  };
  const ifQuickreply = (data) => {
    const buttons = typeof data === "string" ? JSON.parse(data) : data;
    if (
      buttons?.some((obj) => obj.type !== "URL" && obj.type !== "PHONE_NUMBER")
    ) {
      return (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            maxWidth: "295px",
            justifyContent: "center",
          }}
        >
          {buttons?.map((item) => (
            <p
              style={{
                color: "#33b7f6",
                textAlign: "center",
                margin: "2px",
                background: "#ffffff",
                minWidth: "100px",
                cursor: "pointer",
                padding: "10px 15px",
                borderRadius: "10px",
                flexGrow: 1,
              }}
            >
              {item.text}
            </p>
          ))}
        </div>
      );
    }
  };

  useEffect(() => {
    const tpl = watchAllFields?.template;
    if (!tpl?.name) {
      setPreview(null); // Clear if selection is removed
      return;
    }

    // IMMEDIATELY clear the old preview and start loading
    setPreview(null); 
    setPreviewLoading(true);

    apiTemplatePreview({ template_name: tpl.name })
      .then((res) => {
        const type = tpl.template_type;

        if (res?.commerce_catalog_id) {
          fetchProducts(res.commerce_catalog_id, appToken)
            .then((list) => setProducts(list?.data || list))
            .catch(() => setProducts([]));
        } else {
          setProducts([]);
        }

        // Card/Section processing logic stays the same...
        let finalCards = [];
        if (Array.isArray(res.cards)) {
          finalCards = buildCardPreview(
            type === "product_card_carousel" 
              ? enrichCardsWithProducts(res.cards, products) 
              : res.cards
          );
        }

        let finalSections = [];
        if (Array.isArray(res.product_sections)) {
          finalSections = enrichSectionsWithProducts(
            res.product_sections,
            products
          );
        }

        setPreview({
          ...res,
          template_type: type,
          cards: finalCards,
          product_sections: finalSections,
        });
      })
      .catch((error) => {
        notify("error", "Failed to load template preview");
      })
      .finally(() => {
        setPreviewLoading(false);
      });
  }, [watchAllFields?.template?.name]);

  const debouncedTemplates = debounce((searchKey) => {
    loadTemplates(searchKey);
  }, 600);


  useEffect(() => {
    if (isOpen) {
      loadTemplates();
    }
  }, [isOpen]);

  useEffect(() => {
    if (watchAllFields?.template) {
      setTemplate(watchAllFields?.template);
    }
  }, [watchAllFields]);
  return (
    <>
      <Dialog open={isOpen} onClose={closeDialog}>
        <DialogTitle>Send Template</DialogTitle>
        <DialogContent>
          <div
            style={{
              width: "500px",
              height: "450px",
            }}
          >
            <Controller
              render={({ field: { value, onChange } }) => (
                <Autocomplete
                  value={value}
                  options={templates ? templates : []}
                  loading={loadingTemplates}
                  getOptionLabel={(option) =>
                    option?.name + (
                      ["media_card_carousel","product_card_carousel","multi_product_message"].includes(option?.template_type)
                        ? ` (${option.template_type})`
                        : ""
                    )
                  }
                  onInputChange={(e, newInputValue) => {
                    debouncedTemplates(newInputValue);
                  }}
                  onChange={(e, data) => {
                    onChange(data);
                  }}
                  loadingText="Loading..."
                  noOptionsText="No options"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      error={Boolean(errors.template)}
                      helperText={errors.template && "Template is required"}
                      placeholder="Select From the List"
                    />
                  )}
                />
              )}
              rules={{ required: "Template is required" }}
              name="template"
              control={control}
            />
            <div className="templateReview">
              {watchAllFields?.template?.name ? (
                <>
                  {preview ? (
                    <>
                      <div className="preview">
                        <div className="previewMCtr">
                          {preview.header &&
                          preview.header.includes("http") &&
                          preview.header.includes(".pdf") ? (
                            <>
                              <a
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "5px",
                                  paddingTop: "5px",
                                  borderTop: "1px solid #f2f2f2",
                                }}
                                href={preview.header}
                                target="_blank"
                                name="header"
                              >
                                <PictureAsPdfIcon />
                                {fileName}
                              </a>
                            </>
                          ) : preview.header &&
                            preview.header.includes("http") ? (
                            <Avatar
                              src={preview.header}
                              alt="Image Preview"
                              style={{ marginTop: "10px" }}
                              name="header"
                            />
                          ) : (
                            <p>{preview.header}</p>
                          )}
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            {parseFormattedText(preview?.body)}
                          </p>
                          <p>{preview.footer}</p>
                          {ifCallTOAction(preview.buttons)}

                          {watchAllFields?.template?.template_type === 'media_card_carousel' && (
                            <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, py: 1 }}>
                              {preview.cards.map((c, i) => (
                                <Card key={i} sx={{ minWidth: 200, borderRadius: 2, boxShadow: 1 }}>
                                  {c._preview_src && (
                                    <CardMedia component="img" image={c._preview_src} sx={{ height: 140, objectFit: "cover", borderRadius: "8px 8px 0 0" }} />
                                  )}
                                  <CardContent sx={{ pt: 1 }}>
                                    <Typography variant="subtitle2" fontWeight="bold">{c.title}</Typography>
                                    {c.description && (
                                      <Typography variant="body2" color="text.secondary">{c.description}</Typography>
                                    )}
                                    <Stack direction="row" gap={1} sx={{ mt: 1 }}>
                                      {(c.buttons || []).map((btn, bi) => (
                                        <Button key={bi} variant="outlined" size="small" fullWidth sx={{ mt: 1 }}>
                                          {btn.text}
                                        </Button>
                                      ))}
                                    </Stack>
                                  </CardContent>
                                </Card>
                              ))}
                            </Box>
                          )}

                          {watchAllFields?.template?.template_type === 'product_card_carousel' && (
                            <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, py: 1 }}>
                              {preview.cards.map((c, i) => (
                                <Card key={i} sx={{ minWidth: 220, borderRadius: 2, boxShadow: 1 }}>
                                  {c._preview_src && (
                                    <CardMedia
                                      component="img"
                                      image={c._preview_src}
                                      sx={{ height: 140, objectFit: 'cover' }}
                                    />
                                  )}
                                  <CardContent sx={{ pt: 1 }}>
                                    <Typography variant="subtitle2">{c.title || c.product_id}</Typography>
                                    {c.price && (
                                      <Typography variant="body2" color="text.secondary">
                                        {c.price}
                                      </Typography>
                                    )}
                                    <Button variant="outlined" fullWidth sx={{ mt: 1 }}>
                                      View
                                    </Button>
                                  </CardContent>
                                </Card>
                              ))}
                            </Box>
                          )}

                          {watchAllFields?.template?.template_type === 'multi_product_message' && (
                            <Stack gap={1} sx={{ py: 1 }}>
                              {preview.product_sections.map((s, i) => (
                                <Card key={i} sx={{ borderRadius: 2, boxShadow: 1 }}>
                                  <CardContent sx={{ py: 1 }}>
                                    <Typography variant="subtitle2">{s.title}</Typography>
                                    <Stack sx={{ mt: 1 }}>
                                      {(s.products || []).map((p, pi) => (
                                        <Box
                                          key={pi}
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            borderBottom: '1px solid #eee',
                                            pb: 1,
                                          }}
                                        >
                                          {p.image_url && (
                                            <Avatar src={p.image_url} alt={p.name} sx={{ width: 48, height: 48, mr: 1 }} />
                                          )}
                                          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexGrow: 1 }}>
                                            <Typography variant="body1">{p.name || p.title || p.product_id}</Typography>
                                            <Typography variant="body1">{p.price}</Typography>
                                          </Box>
                                        </Box>
                                      ))}
                                    </Stack>
                                  </CardContent>
                                </Card>
                              ))}
                            </Stack>
                          )}
                        </div>
                      </div>
                      {ifQuickreply(preview.buttons)}
                    </>
                  ) : (
                    <p>Loading...</p>
                  )}
                </>
              ) : (
                <p style={{ textAlign: "center" }}>
                  Select Template to preview
                </p>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div style={{ padding: "0 20px 20px 0" }}>
            <Button
              disabled={!watchAllFields.template}
              onClick={handleSendTemplate}
            >
              Send
            </Button>
            <Button onClick={closeDialog}>Cancel</Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default SendMessageTemplate;
